import CyclingCacheListener from "./CyclingCacheListener";

/**
 * @abstract
 */
export default class CachedInstance {
    constructor() {
        /**
         * @type {boolean}
         */
        this.finishedAndAvailable = true; // this must start out as true

        /**
         * @type {CyclingCacheListener}
         */
        this.listener = null;
    }

    /**
     * @returns {boolean}
     */
    isFinishedAndAvailable() {
        return this.finishedAndAvailable;
    }
    
    /**
     * @param {boolean} finishedAndAvailable 
     */
    reset(finishedAndAvailable) {
        if (this.finishedAndAvailable != finishedAndAvailable && this.listener) {
            this.listener.onAvailabilityChanged(finishedAndAvailable);
        }
        this.finishedAndAvailable = finishedAndAvailable;
    }

    /**
     * @param {CyclingCacheListener} listener 
     */
    setCycleCacheListener(listener) {
        this.listener = listener;
    }

}